import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: "reverb",
  key: process.env.REACT_APP_REVERB_KEY,
  wsHost: process.env.REACT_APP_REVERB_HOST || "127.0.0.1",
  wsPort: process.env.REACT_APP_REVERB_PORT || 8080,
  forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
  enabledTransports: ["ws"],
  authEndpoint: `${process.env.REACT_APP_MAIN_SITE_URL}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Accept: "application/json",
    },
  },
});

export default echo;